import { Delete } from '@mui/icons-material';
import { Box, Button, Card, Chip, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import deleteQuote from '../../../../../../hooks/quotes/deleteQuote';
import ArrowReturnIcon from '../../../../../svg-icons/ArrowReturnIcon';
import SAVOrderIcon from '../../../../../svg-icons/SAVOrderIcon';

export const QuotesFormHeader = ({ handleShowComponent, draftQuote }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDeleteQuote = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    await deleteQuote(draftQuote.reference);
    setIsDeleting(false);
    handleShowComponent(null);
  };

  return (
    <Card
      elevation={5}
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        padding: 2,
        mb: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <SAVOrderIcon fontSize="small" color="primary" />
          <Typography color="primary">
            Création / modification d&apos;un devis
          </Typography>
        </Box>
        <Button
          onClick={() => handleShowComponent(null)}
          variant="outlined"
          size="small"
          sx={{ position: 'absolute', top: 16, left: 16 }}
        >
          <ArrowReturnIcon fontSize="small" />
          <span style={{ marginLeft: 4, fontSize: '0.9em' }}>Retour</span>
        </Button>
        {draftQuote && (
          <Box
            sx={{
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              right: 16,
              top: 16,
            }}
          >
            <Chip
              label={draftQuote.reference}
              color="primary"
              variant="outlined"
              size="small"
            />
            <Tooltip title="Supprimer le devis" placement="top">
              <Delete
                onClick={handleDeleteQuote}
                fontSize="small"
                color={isDeleting ? 'disabled' : 'error'}
                size="small"
                variant="outlined"
                sx={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </Box>
        )}
      </Box>
    </Card>
  );
};
